export function isUrlRelative(url: string = '') {
  // "/path" should match but "//google.com" not.
  return url.startsWith('/') && url.slice(1, 2) !== '/';
}
